// extracted by mini-css-extract-plugin
export var center = "_19-2";
export var clickableRow = "_19-5";
export var expandedRow = "_19-7";
export var hoverable = "_19-4";
export var left = "_19-1";
export var right = "_19-3";
export var row = "_19-0";
export var selectedRow = "_19-6";
export var summaryRow = "_19-8";